import type { CSSProperties } from "react";
import { columnAlign } from "./columnLayout";
import type { Column } from "./DataTableTypes";

/** Placeholder rows while loading, at most one page. */
export const SKELETON_ROWS = 8;
/** Placeholder rows for minimal tables, which are small lists. */
export const MINIMAL_SKELETON_ROWS = 3;

/** Varied bar widths, so the placeholder looks like text of different lengths. */
const TEXT_BAR_WIDTHS = ["72%", "54%", "86%", "64%", "46%", "78%"];
const TEXT_BAR = { height: 10, borderRadius: 5 };
const BADGE_BAR = { width: 72, height: 20, borderRadius: 999 };

/** Number of placeholder rows: never more than fit on a page. */
export function skeletonRowCount(pageSize: number, maxRows: number): number {
  return Math.min(pageSize, maxRows);
}

/** Shape of the placeholder bar in the cell at (`rowIndex`, `columnIndex`). */
export function skeletonBarStyle<R>(col: Column<R>, rowIndex: number, columnIndex: number): CSSProperties {
  const isBadge = col.type === "badge";
  return {
    width: isBadge ? BADGE_BAR.width : TEXT_BAR_WIDTHS[(rowIndex + columnIndex) % TEXT_BAR_WIDTHS.length],
    height: isBadge ? BADGE_BAR.height : TEXT_BAR.height,
    borderRadius: isBadge ? BADGE_BAR.borderRadius : TEXT_BAR.borderRadius,
    marginLeft: columnAlign(col) === "right" ? "auto" : undefined,
  };
}
